module.exports = __webpack_public_path__ + "static/media/home-bg-desktop.eefc2b87.webp";